'use strict';

import * as THREE from "three";
import TWEEN from '../../../js/libs/tween.umd';
import gsap from 'gsap';

import {backgroundHide} from "../threejs/sceneBackground";
import {environmentHide} from "../threejs/environment";
import {changeLightEnvironment} from "../threejs/lights";
import {CardTypes, ViewMode} from "../../common";
import { updateSearchResults } from '../search/search';
import {hidePointsModels} from "../points/points";
import {updateRenderer} from "../../app";
import {
    cylinderFloorNumbers,
    removeCylinderFloorNumbers,
    rotateCylinderFloorNumbers,
    showOrHideCylinderFloorNumbers
} from "../cylinderFloorNumbers/cylinderFloorNumbers";
import { additionalMenuToggle, mobileBurgerStyleToggle } from '../menu/menu';
import {
    showRightNavBar
} from '../navigation/right-nav-bar';
import {
    getOrbitControlsDistanceAndPan,
    getPolarAngleFromViewMode, getWorldData,
    resetPanLimits,
    setMinAndMaxControlsDistance, setOrbitControls,
    setPanLimits, setPolarAngle, setSmoothDistance,
} from '../controls/orbitControls';
import { Buildings, projectMode, settingsData, threeJsVariables } from '../../settings';
import { changeBorderRadius, removeSelectionBoxesLockColor, userPrevent } from '../../functions';
import { animateCamera } from '../threejs/animation';
import { hideCylindersGrid, showCylinderGrid } from '../cylinderGrid/cylinderGrid';
import { Vector3 } from 'three';
import { autoZoomIsActive, fitModelInViewport, getZoomParams } from '../controls/zoomControl';
import {toggleStreetNames} from "../street-names/addStreetNames";
import { poiToggle } from '../poi/poiCss';
import { getSelectionsByName } from '../threejs/autoSelectionBoxes'
import { setActiveMultiSearchButton } from '../search/multipleSearch';
import {UnitCardClass} from "../cards/unitCards/UnitCardClass";
import { getCurrentLang } from '../language/langSwitcher';

let _currentSelectionBoxes = null


export const BuildingSwitch = {
    add: function (container) {
        if (!document.getElementById('building-switcher')) {
            let buildings_list_html = '';

            Buildings.getBuildingsArray().forEach((building, i) => {
                let towerName;

                if (Array.isArray(building.info.towerName)){
                    towerName = building.info.towerName.find(el => el.lang === getCurrentLang()).value;
                } else {
                    towerName = building.info.towerName;
                }

                buildings_list_html += `<div class="building-item" data-building="${building.name}" data-index="${i}"><span>${towerName}</span></div>`;
            });

            container.insertAdjacentHTML('beforeend', `<div id="building-switcher" class="non-canvas">
            <button class="prev-btn new-ui-direction-btn icon-left1"></button>
            <div class="buildings-list">${buildings_list_html}</div>
            <button class="next-btn new-ui-direction-btn icon-right1"></button>
            </div>`);

            if (Buildings.getBuildingsInfoLength() <= 1) {
                document.querySelector('#building-switcher').classList.add('hide');
            }

            document.querySelector('#building-switcher .building-item').classList.add("active");

            let nav_btns = document.querySelectorAll('#building-switcher .new-ui-direction-btn');

            if (nav_btns) {
                nav_btns.forEach(function (btn) {
                    btn.addEventListener('click', function () {

                        if (userPrevent() || settingsData.activeModeSwitching) return;

                        settingsData.activeModeSwitching = true;

                        // if (settingsData.bombBlock || !threeJsVariables.orbitControls.enabled) return;
                        // settingsData.bombBlock = true;

                        const items_list = document.querySelectorAll('#building-switcher .building-item');
                        const active_item = document.querySelector('#building-switcher .building-item.active');
                        if (this.classList.contains('next-btn')) {
                            let target_index = Number(active_item.getAttribute('data-index')) + 1;
                            if (items_list.length === target_index) {
                                target_index = 0;
                            }

                            const targetName = document.querySelector(`.building-item[data-index="${target_index}"]`).getAttribute('data-building');

                            projectMode.Cylinder.switchBuilding(targetName);

                        } else {
                            let target_index = Number(active_item.getAttribute('data-index')) - 1;
                            if (target_index < 0) {
                                target_index = items_list.length - 1;
                            }
                            const targetName = document.querySelector(`.building-item[data-index="${target_index}"]`).getAttribute('data-building');

                            projectMode.Cylinder.switchBuilding(targetName);
                        }
                    });
                });
            }
            changeBorderRadius(document.getElementById('building-switcher'));

            return document.querySelector('#building-switcher');
        }
    },

    changeLanguage: function(){
        const items = document.querySelectorAll('.building-item');

        items.forEach(item => {
            // const dataIndex = Number(item.getAttribute('data-index'));
            const dataName = item.getAttribute('data-building');
            const buildingInfo = Buildings.getBuilding(dataName).info;

            let name;

            if (Array.isArray(buildingInfo.towerName) && buildingInfo.towerName.length){
                name = buildingInfo.towerName.find(name => name.lang === getCurrentLang()).value;
            } else {
                name = buildingInfo.towerName;
            }

            item.firstElementChild.textContent = name;
        });


    },

    // change_building_to: function (building_index) {
    //     if (buildings_info[building_index].floor_obj === 0) {
    //         return;
    //     }
    //
    //     removeSelectionBoxesLockColor();
    //
    //     if (document.getElementById('building-switcher')) {
    //         let items_list = document.querySelectorAll('#building-switcher .building-item');
    //         let active_item = document.querySelector('#building-switcher .building-item.active');
    //
    //         active_item.classList.remove('active');
    //         items_list[building_index].classList.add('active');
    //         // buildingSwitcherButtonsToggle(building_index);
    //         camera_change_animation(building_index);
    //         // setOrbitControls(ViewMode.Cylinder);
    //         // setPolarAngle(ViewMode.Cylinder);
    //     }
    // }
}

export function hideBuildingSwitcher () {
    const switcher = document.querySelector('#building-switcher');
    if (switcher){
        gsap.to(switcher,{bottom: -100, opacity:0, duration: 1,onComplete:()=>{
                switcher.classList.add('hide');
                switcher.classList.remove('showed');
                resetBuildingSwitcherAnimation(switcher);
        }});
    }
}

export function showBuildingSwitcher () {
    let switcher = document.querySelector('#building-switcher');

    if (!switcher){
        // if (buildings_info.length > 1){
        switcher = BuildingSwitch.add(document.querySelector('.main-wrap'));
        // } else if (buildings_info.length === 1) {
        //     return;
        // }
    }

    if (switcher.classList.contains('showed') || Buildings.getBuildingsInfoLength() <= 1){
        return;
    }

    let activeItem = document.querySelector('#building-switcher .building-item.active');
    activeItem && activeItem.classList.remove('active');

    const activeBuilding = Buildings.getActiveBuilding();
    const buildingItem = switcher.querySelector(`.building-item[data-building="${activeBuilding.name}"]`);
    buildingItem.classList.add('active');

    gsap.fromTo(switcher,{bottom: -100,opacity: 0},{bottom:32, opacity:1, duration: 1,
        onStart:()=>{
            switcher.classList.remove('hide');
        },onComplete:()=>{
            resetBuildingSwitcherAnimation(switcher);
            switcher.classList.add('showed');
        }});
}

function resetBuildingSwitcherAnimation (switcher) {
    switcher.style.removeProperty('bottom');
}

export function showBuildings () {
    const buildingToShow = Buildings.getActiveBuilding();

    // buildingsToShow.forEach(building => {
        buildingToShow.modelGroup.traverse(mesh => {
            if (mesh.isMesh) {
                const animation = gsap.to(mesh.material, {
                    duration: .1,
                    opacity: 1,
                    onStart: () => {
                        settingsData.bombBlock = true;
                        buildingToShow.modelGroup.visible = true;
                    },
                    onComplete: () => {
                        mesh.material.transparent = config.resources.bundle?.material.transparent || false;
                        // buildingToShow.group.visible = true;
                        buildingToShow.isHide = false;
                        settingsData.bombBlock = false;
                    }
                });
            }
        });
    // });
}

export function hideBuildings () {
    const buildingsToHide = Buildings.getDeactivatedBuildings();

    if (!buildingsToHide.length) return;

    buildingsToHide.forEach(building => {
        building.modelGroup.traverse(mesh => {
            if (mesh.isMesh) {
                const animation = gsap.to(mesh.material, {
                    duration: 1,
                    transparent: true,
                    opacity: config.features.buildingOpacity ? config.features.buildingOpacity : 0,
                    onStart: () => {
                        settingsData.bombBlock = true;
                    },
                    onComplete: () => {
                        building.modelGroup.visible = Boolean(config.features.buildingOpacity);
                        settingsData.bombBlock = false;
                        building.isHide = true;
                    },
                });
            }
        });
    });
}

// export function showAllBuildings () {
//     if (_currentSelectionBoxes!==null){
//         threeJsVariables.scene.remove(_currentSelectionBoxes)
//         _currentSelectionBoxes = null
//     }
//
//     buildings_info.forEach(building => {
//         settingsData.objects_to_intersection.push(...building.intersections,...settingsData.poiIntersection,...settingsData.additionalIntersectionObjects);
//
//         const buldingsArr = building.objects_to_appear.concat(building.objects_to_opacity);
//
//         buldingsArr.forEach(elements => {
//             elements.traverse(mesh => {
//                 if (mesh.isMesh) {
//                   const animation = new Promise(resolve => {
//                       gsap.to(mesh.material, {
//                           duration: 1,
//                           opacity: 1,
//                           onStart: () => {
//                               settingsData.bombBlock = true;
//                               elements.visible = true;
//                           },
//                           onComplete: () => {
//                               mesh.material.transparent = config.resources.buildings?.texturesSettings?.transparent || false;
//                               settingsData.bombBlock = false;
//                               resolve(true);
//                           }
//                       });
//                   });
//
//                   settingsData.animationsList.push(animation);
//                 }
//             });
//         });
//     });
// }


export function showAllBuildings () {
    const animations = [];

    const buildings = Buildings.getBuildingsArray();

    buildings.forEach(building => {

        settingsData.objects_to_intersection.push(
            ...building.instances,
            ...settingsData.poiIntersection,
            ...settingsData.additionalIntersectionObjects
        );

        if (building.isHide){

            building.modelGroup.traverse(mesh => {
                if (mesh.isMesh) {
                    const animation = new Promise(resolve => {
                        gsap.to(mesh.material, {
                            duration: 1,
                            opacity: 1,
                            onStart: () => {
                                settingsData.bombBlock = true;
                                building.modelGroup.visible = true;
                            },
                            onComplete: () => {
                                mesh.material.transparent = config.resources.bundle.material.transparent || false;
                                settingsData.bombBlock = false;
                                resolve(true);
                            }
                        });
                    });
                    animations.push(animation);
                }
            });

        }

    });

    return Promise.all(animations);
}

//New version when camera move to the building by two steps X and Y axis
// function flyCameraToBuilding(buildingIndex) {
//     const {activeViewMode, globalSettings, perspectiveCamera: camera} = settingsData;
//     const {scene, orbitControls: controls} = threeJsVariables;
//
//     const currentBuilding = getSelectionsByName(buildings_info[buildingIndex].name);
//     const buildingBox = new THREE.Box3().setFromObject(currentBuilding);
//     const buildingCenterPoint = buildingBox.getCenter(new THREE.Vector3());
//     const {minAngle} = getPolarAngleFromViewMode(ViewMode.Cylinder);
//     const {cameraVector, orbitControlsVector} = getWorldData();
//     const {minDistance} = getOrbitControlsDistanceAndPan(ViewMode.Cylinder);
//
//     buildingCenterPoint.y = buildingCenterPoint.y / 1.5;
//
//     const position = {
//         x: buildingCenterPoint.x,
//         y: buildingCenterPoint.y,
//         z: globalSettings.startCamera.side,
//     };
//
//     const startPoint = new THREE.Vector3(cameraVector.x, cameraVector.y, cameraVector.z);
//     // const middlePoint = new THREE.Vector3(buildingCenterPoint.x * 0.6, buildingCenterPoint.y * 1.5, cameraVector.z * 0.8);
//     const middlePoint2 = new THREE.Vector3(buildingCenterPoint.x, buildingCenterPoint.y * 1.5, cameraVector.z * 0.5);
//     const endPosition = new THREE.Vector3(position.x, position.y, position.z);
//
//     const curve = new THREE.CatmullRomCurve3([startPoint, middlePoint2, endPosition]);
//     curve.curveType = 'chordal';
//
//     /*
//     const points = curve.getPoints( 50 );
//     const geometry = new THREE.BufferGeometry().setFromPoints(points);
//     const material = new THREE.LineBasicMaterial({color: 'red', linewidth: 350});
//     const curveLine = new THREE.Line(geometry, material);
//     scene.add(curveLine);
//
//
//
//     const geometry = new THREE.BufferGeometry().setFromPoints([
//         orbitControlsVector,
//         new THREE.Vector3(buildingCenterPoint.x, orbitControlsVector.y, orbitControlsVector.z)
//     ]);
//     const material = new THREE.LineBasicMaterial({color: 'red', linewidth: 150});
//     const curveLine = new THREE.Line(geometry, material);
//     scene.add(curveLine);
//     */
//     let searchContainer = null;
//
//     gsap.to(orbitControlsVector, {
//         duration: 2,
//         ease: "power1.easeInOut",
//         x: buildingCenterPoint.x,
//
//         onStart: () => {
//             controls.enabled = false;
//             settingsData.bombBlock = true;
//             resetPanLimits();
//             buildingsLabelHideWhenAnimationStart();
//             buildingHoverOut();
//             // poiLabelHideWhenAnimationStart();
//             closeUnitCard();
//             manualHide360Icons();
//             showBuildings(buildingIndex);
//             removeSelectionBoxesLockColor();
//             hideCylindersGrid();
//             removeCylinderFloorNumbers();
//             searchContainer = removeSearchContainer('immediately', 'building-switcher');
//         }
//     });
//
//     gsap.to(controls, {
//         duration: 5,
//         ease: "power1.easeInOut",
//         minDistance: minDistance,
//         minPolarAngle: minAngle,
//         // polarCameraCorrection: 15
//         onComplete: () => {
//             setMinAndMaxControlsDistance(ViewMode.Cylinder);
//             setPanLimits(ViewMode.Cylinder);
//         }
//     });
//
//
//
//     const time = new THREE.Clock();
//     const endTime = 4;
//
//     gsap.to(orbitControlsVector, {
//         duration: 2.5,
//         delay: 2.5,
//         ease: "power1.easeInOut",
//
//         y: buildingCenterPoint.y,
//         z: buildingCenterPoint.z
//     });
//
//     const tween = gsap.to(cameraVector, {
//         duration: 15,
//         delay: 1,
//         ease: "power1.easeInOut",
//
//         onUpdate: () => {
//             const elapsedTime = time.getElapsedTime();
//             const timeNew = elapsedTime/endTime;
//
//             const camPos = curve.getPoint(timeNew);
//             camera.position.set(camPos.x, camPos.y, camPos.z);
//
//             if (elapsedTime > endTime) {
//                 tween.kill();
//                 endCameraMove();
//             }
//         },
//     });
//
//     function endCameraMove() {
//             switchBuilding(buildingIndex);
//             showBuildingSwitcher();
//             showRightNavBar();
//             mobileBurgerStyleToggle();
//             setTimeout(()=>{
//                 showOrHideCylinderFloorNumbers();
//                 setTimeout(()=> {
//                     rotateCylinderFloorNumbers();
//                     updateRenderer();
//                 },100);
//             },100);
//             hideBuildings(buildingIndex);
//             showCylinderGrid(buildingIndex + 1);
//             hidePointsModels('Trees small');
//             hidePointsModels('Trees big');
//             backgroundHide();
//             environmentHide();
//             changeLightEnvironment(ViewMode.Cylinder);
//             searchContainer !== null && openSearchHandler();
//
//             if (settingsData.buildingDestroyed) {
//                 flatLabelsUpdate(settingsData.currentFloor);
//             }
//             buildingsLabelResize();
//             buildingsLabelUpdate();
//
//
//             controls.enabled = true;
//             settingsData.bombBlock = false;
//             console.log(orbitControlsVector);
//         }
// }

//Old version when camera move to the building in a short way
async function camera_change_animation(buildingIndex) {
    return ;
    // const isOrbitMode = settingsData.activeViewMode === ViewMode.Orbit;
    // const currentBuilding = getSelectionsByName(buildings_info[buildingIndex].name);
    // const buildingBox = new THREE.Box3().setFromObject(currentBuilding);
    // await fitModelInViewport(false,currentBuilding);
    // const buildingBoxCenter = buildingBox.getCenter(new THREE.Vector3());
    // const buildingCenterPoint = currentBuilding.getWorldPosition(new Vector3()).setY(buildingBoxCenter.y);
    // const {minAngle} = getPolarAngleFromViewMode(ViewMode.Cylinder);
    // const {cameraVector,orbitControlsVector} = getWorldData();
    // const {minDistance, maxDistance} = getOrbitControlsDistanceAndPan(ViewMode.Cylinder);
    // const defaultPosition = config.threejs.animations.defaultForeshortening.position;
    // let length;
    //
    // _currentSelectionBoxes = currentBuilding.parent
    // threeJsVariables.scene.add(_currentSelectionBoxes)
    //
    // if (autoZoomIsActive()){
    //     const { foreshortening } = getZoomParams();
    //     length = foreshortening;
    // } else {
    //     length = (maxDistance + minDistance) / 2;
    // }
    //
    // const duration = (settingsData.orbitAnimationCout === 0) ? 1500 : 1000;
    // const position = new Vector3().subVectors(cameraVector,buildingCenterPoint).normalize().setLength(length).add(buildingCenterPoint);
    //
    // buildingCenterPoint.y = buildingCenterPoint.y / 1.2;
    // let searchContainer = document.querySelector('.search__container-main');
    //
    // if (typeof settingsData.orbitAnimationCout === 'number'){
    //     settingsData.orbitAnimationCout++;
    // }
    //
    // animateCamera(
    //     cameraVector,
    //     position,
    //     orbitControlsVector,
    //     buildingCenterPoint,
    //     undefined,
    //     minDistance,
    //     minAngle,
    //     config.threejs.orbitControls.polarCameraCorrection,
    //     duration,
    //     TWEEN.Easing.Sinusoidal.InOut,
    //     () => {
    //         setSmoothDistance();
    //         backgroundHide();
    //         toggleStreetNames(false);
    //         environmentHide();
    //         isOrbitMode && showCylinderGrid(buildingIndex + 1);
    //         poiToggle(false);
    //         settingsData.bombBlock = true;
    //         closeUnitCard();
    //         manualHide360Icons();
    //         resetPanLimits();
    //         !isOrbitMode && hideCylindersGrid();
    //         hideBuildings(buildingIndex);
    //         // !isOrbitMode && hideBuildings(buildingIndex);
    //         // isOrbitMode && hideBuildings(buildingIndex);
    //         showBuildings(buildingIndex);
    //         removeSelectionBoxesLockColor();
    //         removeCylinderFloorNumbers();
    //         // searchContainer = removeSearchContainer('immediately', 'building-switcher');
    //     },
    //     () => {
    //         setOrbitControls(ViewMode.Cylinder);
    //         setPolarAngle(ViewMode.Cylinder);
    //         // poiToggle(false);
    //         switchBuilding(buildingIndex);
    //         setMinAndMaxControlsDistance(ViewMode.Cylinder);
    //         setPanLimits(ViewMode.Cylinder);
    //         showBuildingSwitcher();
    //         showRightNavBar();
    //         mobileBurgerStyleToggle();
    //         setTimeout(()=>{
    //             showOrHideCylinderFloorNumbers();
    //             setTimeout(()=>{
    //                 rotateCylinderFloorNumbers();
    //                 updateRenderer();
    //             },100);
    //         },100);
    //         // isOrbitMode && hideBuildings(buildingIndex);
    //         showCylinderGrid(buildingIndex + 1);
    //         hidePointsModels('Trees small');
    //         hidePointsModels('Trees big');
    //         // backgroundHide();
    //         // environmentHide();
    //         // toggleStreetNames(false);
    //         changeLightEnvironment(ViewMode.Cylinder);
    //         searchContainer !== null &&  updateSearchResults();
    //         setActiveMultiSearchButton(buildingIndex);
    //         additionalMenuToggle();
    //
    //         settingsData.bombBlock = false;
    //     });

    // const mainLabelContainer = threeJsVariables.labelRenderer.domElement;
    // if (mainLabelContainer){
    //     mainLabelContainer.style.display = 'block';
    //
    //     if (settingsData.activeViewMode !== ViewMode.Cylinder) {
    //         document.querySelector('.building-labels').style.display = 'none';
    //         setTimeout(() => {
    //             document.querySelector('.building-labels').style.display = 'block';
    //             showPoi();
    //         },10);
    //     } else {
    //         document.querySelector('.building-labels').style.display = 'none';
    //     }
    // }

     // animateCameraPosition(
    //   cameraVector,
    //   position,
    //   orbitControlsVector,
    //   buildingCenterPoint,
    //   5,
    //   settingsData.activeViewMode === 'orbit' ? 2000 : 1000,
    //   TWEEN.Easing.Sinusoidal.InOut,
    //   () => {
    //       settingsData.bombBlock = true;
    //       closeUnitCard();
    //       manualHide360Icons();
    //       resetPanLimits();
    //       hideCylindersGrid();
    //       showBuildings(buildingIndex);
    //       removeSelectionBoxesLockColor();
    //       removeCylinderFloorNumbers();
    //       searchContainer = removeSearchContainer('immediately', 'building-switcher');
    //   },
    //   () => {
    //       switchBuilding(buildingIndex);
    //       setMinAndMaxControlsDistance(ViewMode.Cylinder);
    //       setPanLimits(ViewMode.Cylinder);
    //       showBuildingSwitcher();
    //       showRightNavBar();
    //       mobileBurgerStyleToggle();
    //       setTimeout(()=>{
    //           showOrHideCylinderFloorNumbers();
    //           setTimeout(()=>{
    //               rotateCylinderFloorNumbers();
    //               updateRenderer();
    //           },100);
    //       },100);
    //       hideBuildings(buildingIndex);
    //       showCylinderGrid(buildingIndex + 1);
    //       hidePointsModels('Trees small');
    //       hidePointsModels('Trees big');
    //       backgroundHide();
    //       environmentHide();
    //       changeLightEnvironment(ViewMode.Cylinder);
    //       searchContainer !== null && openSearchHandler();
    //
    //       settingsData.bombBlock = false;
    //   });
}

// function switchBuilding(building_index) {
//     buildings_info.forEach((item, index) => {
//         item.isActive = index === building_index;
//     });
//
//     settingsData.objects_to_intersection = buildings_info[building_index].all_apartments.concat(buildings_info[building_index].flooring_obj);
//     settingsData.customSelections = buildings_info[building_index].customSelections;
//     settingsData.objects_to_intersection = settingsData.objects_to_intersection.concat(buildings_info[building_index].customSelections);
//     settingsData.instanced_floors = settingsData.instanced_floors_switch[building_index];
//     settingsData.floor_obj = buildings_info[building_index].floor_obj;
//
//     if (document.querySelector('.search-btn_tooltip')) {
//         settingsData.isSwitched = true;
//     }
//     cylinderFloorNumbers();
//     setTimeout(() => {
//         rotateCylinderFloorNumbers();
//     },1000);
//
// }

// export function buildingSwitcherButtonsToggle(building_index) {
//     if (buildings_info.length < 2){
//         return;
//     }
//
//     const getCameraPosition = threeJsVariables.perspectiveCamera.getWorldPosition(new THREE.Vector3());
//
//     if (settingsData.activeViewMode !== ViewMode.Cylinder && settingsData.activeViewMode !== ViewMode.FloorPlan || threeJsVariables.perspectiveCameraCurrentZpozition && threeJsVariables.perspectiveCameraCurrentZpozition === getCameraPosition.z) {
//         return;
//     }
//
//     if (!building_index) {
//         buildings_info.forEach((building, index) => {
//             if (building.isActive) {
//                 building_index = index;
//             }
//         });
//     }
//
//     threeJsVariables.perspectiveCameraCurrentZpozition = getCameraPosition.z;
//
//     getCameraPosition.z < 0 ? toggleIndex(0, 1, building_index) : toggleIndex(1, 0, building_index);
// }

// function toggleIndex(first, last, building_index) {
//     const btns = document.querySelectorAll('.new-ui-direction-btn');
//     const tooltips = document.querySelectorAll('.search-btn_tooltip');
//
//     if (building_index === 0) {
//         btns[last].setAttribute('disabled', `${true}`);
//         btns[first].removeAttribute('disabled');
//
//         if (tooltips.length > 0) {
//             tooltips[last].style.display = 'none';
//             tooltips[first].style.display = 'flex';
//         }
//     } else if (building_index === buildings_info.length - 1) {
//         btns[first].setAttribute('disabled', `${true}`);
//         btns[last].removeAttribute('disabled');
//
//         if (tooltips.length > 0) {
//             tooltips[first].style.display = 'none';
//             tooltips[last].style.display = 'flex';
//         }
//     } else {
//         btns[first].removeAttribute('disabled');
//         btns[last].removeAttribute('disabled');
//
//         if (tooltips.length > 0) {
//             tooltips[first].style.display = 'flex';
//             tooltips[last].style.display = 'flex';
//         }
//     }
// }


export function closeUnitCard() {
    if (UnitCardClass.findCard()?.html) {
        UnitCardClass.closeMultipleCards();
    }
}

export function enterToTheBuildingWithMaxAvailableApartments () {

    const availableApartments = Buildings.getBuildingsArray().reduce((acc,value) =>{

        if (Object.keys(value.info).length){

            acc.push({
                name: value.name,
                availableApartments: value.info.availableApartments
            });
        }

        return acc;
    },[]);

    const maxValue = Math.max(...availableApartments.map(building => building.availableApartments));
    const name = availableApartments.find(building => building.availableApartments === maxValue).name;

    projectMode.Cylinder.enter(Buildings.getBuilding(name));
}